import React, { useState, useEffect } from "react";
import DashboardHeader from "./components/DashboardHeader";
import Firstsection from "./components/Firstsection";
import { useSelector } from "react-redux";
import { getPayinByOrgName, getPayoutByOrgName,getPayinByOrgAndPG,getPayoutByOrgAndPG } from "../../config/LiveApi";
import SecondSection from './components/SecoundSection';
import Spinner from "../Spin/Spinner";
import ThirdSection from "./components/ThirdSection";

// Simple Loading Spinner
const LoadingSpinner = () => (
 <Spinner/>
);

const DashboardAnalyst = () => {
  const [orgName, setOrgName] = useState("");
  const [payInStatistic, setPayInStatistic] = useState(null);
  const [payoutStatistic, setPayoutStatistic] = useState(null);   
  // const [finalLoading, setFinalLoading] = useState(false);
  const [payInLoading, setPayInLoading] = useState(false);
  const [payoutLoading, setPayoutLoading] = useState(false);
  const [startDate, setStartDate] = useState(() => {
    const today = new Date();
    return new Date(today.setHours(0, 0, 0, 0));
  });
  const [endDate, setEndDate] = useState(() => {
    const today = new Date();
    return new Date(today.setHours(23, 59, 59, 999));
  });

  const token = useSelector((store) => store.userReducer.token);
  const [selectedProvider, setSelectedProvider] = useState("All");

  const fetchPayInData = async () => {
    try {
      setPayInLoading(true);
      let payInData;
      if (selectedProvider === "All") {
        payInData = await getPayinByOrgName(
          token,
          orgName,
          startDate.toISOString(),
          endDate.toISOString()
        );
      } else {
        payInData = await getPayinByOrgAndPG(
          token,
          orgName,
          selectedProvider,
          startDate.toISOString(),
          endDate.toISOString()
        );
      }
      setPayInStatistic(payInData);
    } catch (error) {
      console.error("Error fetching pay-in data:", error);
    } finally {
      setPayInLoading(false);
    }
  };

  const fetchPayoutData = async () => {
    try {
      setPayoutLoading(true);
      let payoutData;
      if (selectedProvider === "All") {
        payoutData = await getPayoutByOrgName(
          token,
          orgName,
          startDate.toISOString(),
          endDate.toISOString()
        );
      } else {
        payoutData = await getPayoutByOrgAndPG(
          token,
          orgName,
          selectedProvider,
          startDate.toISOString(),
          endDate.toISOString()
        );
      }
      setPayoutStatistic(payoutData);
    } catch (error) {
      console.error("Error fetching payout data:", error);
    } finally {
      setPayoutLoading(false);
    }
  };


  // useEffect(() => {
  //   if (token && orgName) {
  //     fetchPayInData();
  //     fetchPayoutData();
  //   }
  // }, [token, orgName,selectedProvider, startDate, endDate]);

  useEffect(() => {
    let isMounted = true;

    if (token && orgName) {
      const fetchData = async () => {
        try {
          setPayInLoading(true);
          setPayoutLoading(true);

          let payInData;
          let payoutData;
          if (selectedProvider === "All") {
            payInData = await getPayinByOrgName(
              token,
              orgName,
              startDate.toISOString(),
              endDate.toISOString()
            );
            payoutData = await getPayoutByOrgName(
              token,
              orgName,
              startDate.toISOString(),
              endDate.toISOString()
            );
          } else {
            payInData = await getPayinByOrgAndPG(
              token,
              orgName,
              selectedProvider,
              startDate.toISOString(),
              endDate.toISOString()
            );
            payoutData = await getPayoutByOrgAndPG(
              token,
              orgName,
              selectedProvider,
              startDate.toISOString(),
              endDate.toISOString()
            );
          }
          if (isMounted) {
            setPayInStatistic(payInData);
            setPayoutStatistic(payoutData);
          }
        } catch (error) {
          console.error("Error fetching data:", error);
        } finally {
          if (isMounted) {
            setPayInLoading(false);
            setPayoutLoading(false);
          }
        }
      };

      fetchData();
    }
    return () => {
      isMounted = false;
    };
  }, [token, orgName, selectedProvider, startDate, endDate]);

  const finalLoading = payInLoading || payoutLoading;

  return (
    <div>
      <DashboardHeader onOrgNameChange={setOrgName} onProviderChange={setSelectedProvider}
      onDateChange={(start, end) => {
        setStartDate(new Date(start));
        setEndDate(new Date(end));
      }}/>
       {!orgName ? (
        <div style={{ marginTop: "12rem", textAlign: "center", color: "#777" , fontWeight:700 }}>
          Please select a Organization to view dashboard
        </div>
      ) : finalLoading ? (
        <LoadingSpinner />
      ) : (
        <>
          <Firstsection
            payInStatistic={payInStatistic}
            payoutStatistic={payoutStatistic}
            loading={finalLoading}
          />
          <SecondSection
            payInStatistic={payInStatistic}
            payoutStatistic={payoutStatistic}
            loading={finalLoading}
          />

          <ThirdSection
            payInStatistic={payInStatistic}
            payoutStatistic={payoutStatistic}
            loading={finalLoading}
          />
        </>
      )}
    </div>
  );
};

export default DashboardAnalyst;
